import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DashboardComponent } from './component/dashboard/dashboard.component';
import { AvailabilityComponent } from './component/availability/availability.component';
import { TableManagementComponent } from './component/table-management/table-management.component';
import { LoginComponent } from './component/login/login.component';
import { AuthGuard } from './auth.guard';


const routes: Routes = [
  { path: '', redirectTo: '/reservations', pathMatch: 'full'},
  { path: 'reservations', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'availability', component: AvailabilityComponent, canActivate: [AuthGuard]},
  { path: 'tables', component: TableManagementComponent, canActivate: [AuthGuard]},
  { path: 'login', component: LoginComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
